import { getFirestore, doc, collection, query, getDoc, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'skills/'

function docToInstance(document) {
  const data = document.data()
  if (data) {
    return new Skill(document.id, data.name)
  }
  return null
}
export default class Skill {
  constructor(id, name) {
    this.id = id
    this.name = name
  }

  static initOne() {
    return new Skill(null, 'Nouvelle compétence')
  }

  async save() {
    const data = {
      name: this.name,
    }

    if (this.id) {
      await catalogueCommands.skill.update(this.id, data)
    } else {
      const result = await catalogueCommands.skill.create(data)
      this.id = result.id
    }
    return this
  }
  async delete() {
    await catalogueCommands.skill.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getById(id) {
    const document = await getDoc(doc(db, await getCollectionPath(collectionName), id))
    return docToInstance(document)
  }

  static async getAll() {
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }
}
